// extracted by mini-css-extract-plugin
module.exports = {"Footer":"_1Z3j8","apps":"_1akmY","icons":"QYD_t"};